import moment from "moment/moment";
import CryptoJS from "crypto-js";
import { appSecret } from "./Contant";
import Swal from "sweetalert2";

export const formatDateToDDMMYYYY = (dateString) => {
  if (dateString === null || dateString === undefined || dateString === "")
    return "";
  // Format date as MM/DD/YYYY (month/date/year)
  return moment(dateString).format("MM/DD/YYYY h:mm A");
};

export const ROLES = {
  admin: "role_rtL:BY:(tY",
  mgr: "role_C$VKrq_+$z",
  hr: "role_Rkr_+Y%_a%",
  emp: "role_dtFe_2T7M)",
  // Aliases for better readability
  MANAGER: "role_C$VKrq_+$z",
  EMPLOYEE: "role_dtFe_2T7M)",
};

export const formatLabel = (key) => {
  if (!key) return;
  return key
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase());
};

export const decrypt = (encryptedValue) => {
  try {
    const decodedKey = CryptoJS.enc.Base64.parse(appSecret);
    const encryptedData = CryptoJS.enc.Base64.parse(encryptedValue);
    const bytes = CryptoJS.AES.decrypt(
      { ciphertext: encryptedData },
      decodedKey,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    const decryptedValue = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedValue;
  } catch (error) {
    console.error("Error decrypting value:", error);
    return null;
  }
};

export const ROLE_NAMES = {
  Admin: "role_rtL:BY:(tY",
  Manager: "role_C$VKrq_+$z",
  HR: "role_Rkr_+Y%_a%",
  User: "role_dtFe_2T7M)",
};

export const getRoleFromRoleId = (id) => {
  const key = Object.keys(ROLE_NAMES).find((key) => ROLE_NAMES[key] === id);
  return key;
};

export const trimObjectValues = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map(trimObjectValues);
  } else if (typeof obj === "object" && obj !== null) {
    return Object.keys(obj).reduce((acc, key) => {
      acc[key] = trimObjectValues(obj[key]);
      return acc;
    }, {});
  } else if (typeof obj === "string") {
    return obj.trim();
  }
  return obj;
};

export const STATUS = {
  NOT_STARTED: "NOT_STARTED",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  UNDER_REVIEW: "UNDER_REVIEW",
  APPROVED: "APPROVED",
  FINAL_REVIEWED: "FINAL_REVIEWED",
  CHANGE_REQUEST: "CHANGE_REQUEST",
  NEED_DISCUSSION: "NEED_DISCUSSION",
};

export const getStatusNameByValue = (value) => {
  const {
    NOT_STARTED,
    IN_PROGRESS,
    COMPLETED,
    UNDER_REVIEW,
    FINAL_REVIEWED,
    APPROVED,
    CHANGE_REQUEST,
    NEED_DISCUSSION,
  } = STATUS;
  if (value === NOT_STARTED) {
    return <span className="text-[#B0B0B0]">Not Started</span>;
  } else if (value === IN_PROGRESS) {
    return <span className="text-[#2196F3]">In Progress</span>;
  } else if (value === COMPLETED) {
    return <span className="text-[#009688]">Manager Review</span>;
  } else if (value === UNDER_REVIEW) {
    return <span className="text-[#FF9800]">Under Review</span>;
  } else if (value === APPROVED) {
    return <span className="text-[#66BB6A]">Pending Final Review</span>;
  } else if (value === FINAL_REVIEWED) {
    return <span className="text-[#9C27B0]">Final Reviewed</span>;
  } else if (value === CHANGE_REQUEST) {
    return <span className="text-[#F44336]">Change Request</span>;
  } else if (value === NEED_DISCUSSION) {
    return <span className="text-[#6e07f4e3]">Appraisal Discussion</span>;
  }
};

const ratingList = [
  {
    value: 0,
    label: <span className="text-[#B0B0B0]"></span>,
    key: "NOT_FOUND",
  },
  {
    value: 1,
    label: <span className="text-[#E74C3C]">Unsatisfactory</span>,
    key: "POOR",
  },
  {
    value: 2,
    label: <span className="text-[#a33bff]">Needs Improvement</span>,
    key: "FAIR",
  },
  {
    value: 3,
    label: <span className="text-[#5DADE2]">Meets Expectations</span>,
    key: "AVERAGE",
  },
  {
    value: 4,
    label: <span className="text-[#ffd600]">Exceeds Expectations</span>,
    key: "GOOD",
  },
  {
    value: 5,
    label: <span className="text-[#388E3C]">Excellent</span>,
    key: "EXCELLENT",
  },
];

export const getRatingName = (value) => {
  return ratingList.find((item) => item.value === value)?.label;
};

export const getRatingNameValue = (name) => {
  return ratingList.find((item) => item.key === name)?.value;
};

export const getRatingNameFromValue = (name) => {
  const data = ratingList.find((item) => item.key === name);
  return data.label; //<span className={`text-[${data.}]`}>{data?.label}</span>
};

export const ratingOptions = [
  { label: "Excellent", value: "Excellent" },
  { label: "Exceeds Expectations", value: "Exceeds Expectations" },
  { label: "Meets Expectations", value: "Meets Expectations" },
  { label: "Unsatisfactory", value: "Unsatisfactory" },
  { label: "Needs Improvement", value: "Needs Improvement" },
];

export const statusOption = [
  { label: "Completed", value: "COMPLETED" },
  { label: "In Progress", value: "IN_PROGRESS" },
  { label: "Not Started", value: "NOT_STARTED" },
  { label: "Pending Final Review", value: "APPROVED" },
  { label: "Need Discussion", value: "NEED_DISCUSSION" },
];

export const reminderIntervalList = [
  { label: "Daily", value: 1 },
  { label: "Alternate Days", value: 2 },
  { label: "Weekly", value: 7 },
];

/**
 * Decode JWT token to extract user information
 * @param {string} token - JWT token string
 * @returns {object|null} Decoded token payload or null if invalid
 */
export const decodeJWT = (token) => {
  if (!token) return null;

  try {
    // JWT structure: header.payload.signature
    const parts = token.split(".");
    if (parts.length !== 3) {
      console.error("Invalid JWT token structure");
      return null;
    }

    // Decode the payload (second part)
    const payload = parts[1];

    // Base64 decode and parse JSON
    const decodedPayload = JSON.parse(
      atob(payload.replace(/-/g, "+").replace(/_/g, "/"))
    );

    return decodedPayload;
  } catch (error) {
    console.error("Error decoding JWT token:", error);
    return null;
  }
};

/**
 * Extract user details from JWT token
 * @param {string} token - JWT token string
 * @returns {object|null} User object with details or null if extraction fails
 */
export const extractUserFromToken = (token) => {
  const decoded = decodeJWT(token);

  if (!decoded) return null;

  // Extract user information from the decoded token
  const roleId = decoded.roleId || null;
  const roleName = roleId ? getRoleFromRoleId(roleId) : "User";

  return {
    id: decoded.id || null,
    firstName: decoded.firstName || "",
    lastName: decoded.lastName || "",
    email: decoded.sub || decoded.email || "",
    corporateEmail: decoded.sub || decoded.email || "",
    userRoleId: roleId,
    roleId: roleId,
    roleName: roleName,
    // Add other fields that might be in the token
  };
};


export const showMessage = ({ title, text, icon, confirmButtonColor }) => {
  Swal.fire({
    title: title || "Error!",
    text: text || "Failed to update Business Unit. Please try again.",
    icon: icon || "error",
    confirmButtonColor: confirmButtonColor || icon == "error" ? "#dc2626" : "green",
    customClass: {
      popup: "custom-swal-width",
      icon: "custom-swal-icon",
      title: "custom-swal-title",
      content: "custom-swal-content",
    },
  });
}



export const getLoginUserRoleName = (employeeAppraisals, auth) => {
  if (!employeeAppraisals || employeeAppraisals.length === 0) {
    return "User";
  }
  const isUser = employeeAppraisals.find(
    (appraisal) => appraisal.createdBy === auth.user.id&& appraisal?.submittedBy === "User"
  );
  return isUser ? "User" : "Manager";
};

export const getUserDataBySubmittedBy = (employeeAppraisals, auth) => {
  const filteredData = employeeAppraisals.filter(
    (appraisal) => appraisal.createdBy === auth.user.id 
  );
  console.log("filterData::", filteredData)
  return filteredData?.[0];
};

export const getUserDataBySubmittedRole = (employeeAppraisals, auth,submittedBy) => {
  const filteredData = employeeAppraisals.filter(
    (appraisal) => appraisal.createdBy === auth.user.id && appraisal?.submittedBy === submittedBy
  );
  console.log("filterData::", filteredData)
  return filteredData?.[0];
};


export const getActionType = (actionType) => {
  const actionMap = {
    1: "Draft",
    2: "Submit",
    4: "Change Request",
  };
  return actionMap[actionType] || "Discussion";
};

export const showManagerFeedbackSection = (status, userRoleName,isMangerReviewing) => {

  if (userRoleName === "User") {
    return [STATUS.UNDER_REVIEW, STATUS.CHANGE_REQUEST, STATUS.NEED_DISCUSSION, STATUS.COMPLETED,STATUS.APPROVED,STATUS.FINAL_REVIEWED].includes(status)
  }
  else if(userRoleName === "Manager"||isMangerReviewing){
    return [STATUS.UNDER_REVIEW, STATUS.CHANGE_REQUEST, STATUS.NEED_DISCUSSION, STATUS.COMPLETED,STATUS.APPROVED,STATUS.FINAL_REVIEWED].includes(status)
  }
  return false;

}

export const allowEditMode=(status, userRoleName,isMangerReviewing) => {
 if (userRoleName === "User") {
    return [STATUS.NOT_STARTED,STATUS.IN_PROGRESS, STATUS.CHANGE_REQUEST].includes(status)
  }
  else if(userRoleName === "Manager"||isMangerReviewing){
    return [STATUS.UNDER_REVIEW, STATUS.CHANGE_REQUEST, STATUS.NEED_DISCUSSION, STATUS.COMPLETED].includes(status)
  }
}

